/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 09:59:45
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 15:10:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/index.tsx
 */
import {
  Button,
  DropDown,
  Menu,
  MenuItem,
  Skeleton,
} from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CommonHeader from '@/src/components/CommonHeader';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import {
  activateDiscount,
  archiveDiscount,
  draftDiscount,
  getDiscountDetail,
} from '@/src/request/salesChannel/discounts';
import { saveGiftPurchase } from '@/src/request/salesChannel/discounts/giftPurchase';
import { NEW } from '@/src/tools/constant';
import { EnumSalesChannelMultiLanguage } from '@/src/types/server/params';
import { message } from 'antd';
import { get } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Form } from 'src/components/Antd';
import { handleClick } from 'src/constrains/CreateButtonWithLanguageChangeWarning/tools';
import ModalHoc from 'src/constrains/ModalHOC';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  EnumMultiLanguageType,
  eForceUpdate,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { getParameter, timeoutScroll } from 'src/tools/helper';
import { EnumStatus, StatusChange } from 'src/types/common/discount';
import { modal } from 'src/utils/Modal';
import { DiscountValueType } from '../../Components/AtDiscountValue';
import { ECondition } from '../../Components/CustomerEligibleCondition';
import Attributes from './Attributes';
import BasicInformation from './BasicInformation';
import CustomerEligibleCondition from './CustomerEligibleCondition';
import CustomerGets, {
  ProductsOptionsType,
  TypeOptionsType,
} from './CustomerGets';
import OrderEligibleSection from './OrderEligibleSection';
import UsageLimitation from './UsageLimitation';

import NoPermission from '@/src/components/NoPermission';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { maxPerCustomerCheckbox } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/UsageLimitation';
import { i18nGet } from 'src/tools/tools';
import { discountPermissions } from '../../Components/hooks/permissions';
import Summary from './Summary';
import { breadcrumbData } from './config';
import css from './css.module.less';

interface IParams {
  uuid: string;
  discountUuid: string;
}
const nameDuplicate = 120009;
const formName = 'giftPurchaseEdit';
const GiftPurchaseEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { modalOp, isPrimary } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const [form] = Form.useForm();
  const currentLanguage = useSelector(currentSelectedLanguage());
  const [loading, setLoading] = useState<boolean>(true);
  const [activeTimeError, setActiveTimeError] = useState(false);
  const [used, setUsed] = useState(0);
  const [activeTime, setActiveTime] = useState({
    beginDate: '',
    beginTime: '',
    endDate: '',
    endTime: '',
  });
  const duplicate = getParameter('duplicate');
  const defaultName = getParameter('defaultName');
  const [hasModified, setHasModified] = useState<boolean>(false);
  const [giftPurchaseFormData, setGiftPurchaseFormData] = useState<any>({});
  const [salesChannelName, setSalesChannelName] = useState('');
  const [currency, setCurrency] = useState('');
  const [timezoneInGmt, setTimezoneInGmt] = useState('');
  const history = useHistory();
  const params = useParams<IParams>();
  const { uuid: salesChannelUuid, discountUuid } = params;
  const { canViewDetail, canEdit, canDelete } =
    discountPermissions(salesChannelUuid);

  const isDuplicate = duplicate === 'true';

  //标记是否为Draft状态
  const isDraft =
    giftPurchaseFormData.status == EnumStatus.Draft ||
    giftPurchaseFormData.status == EnumStatus.Expired ||
    discountUuid == NEW ||
    duplicate === 'true';

  useEffect(() => {
    if (canViewDetail) {
      handleRequestDetail(discountUuid);
    }
  }, [duplicate, currentLanguage]);

  const handleRequestDetail = (_discountUuid) => {
    setLoading(true);
    const discountUuidParam = _discountUuid == NEW ? '' : _discountUuid;
    getDiscountDetail(salesChannelUuid, discountUuidParam, {
      [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    }).then((data) => {
      const { salesChannelName, currency, timezoneInGmt } = data || {};
      let { discountVO = {} } = data || {};

      //重写默认值
      const { beginDate = '', beginTime, endDate, endTime } = discountVO || {};
      discountVO = discountVO || {};
      // if (isDuplicate) {
      //   discountVO.usedInOrder = 0;
      // }
      // console.log('discountVO', discountVO);
      discountVO.status = isDuplicate
        ? EnumStatus.Draft
        : discountVO.status || EnumStatus.Draft;
      discountVO.conditions = discountVO.conditions || {};
      discountVO.conditions.enabled = discountVO.conditions.enabled || false;
      discountVO.discountMethod = discountVO.discountMethod || {};
      discountVO.discountMethod.purchaseType =
        discountVO.discountMethod.purchaseType || TypeOptionsType.All;
      discountVO.discountMethod.purchaseItemScope =
        discountVO.discountMethod.purchaseItemScope ||
        ProductsOptionsType.Collections;
      discountVO.discountMethod.discountValue =
        discountVO.discountMethod.discountValue || DiscountValueType.Free;
      discountVO.customerCondition = discountVO.customerCondition || {};
      discountVO.customerCondition.conditionType =
        discountVO.customerCondition.conditionType || ECondition.Everyone;
      if (isDuplicate) {
        discountVO.status = EnumStatus.Draft;
        form.setFieldsValue({
          name: discountVO.name + ' Copy',
          codes: [],
          usePromotionCode: false,
          stackingPrivilegeEnabled: false,
        });
        setUsed(0);
      } else {
        const used = get(discountVO, 'userLimitation.usedCount');
        setUsed(used);
      }
      if (_discountUuid == NEW && defaultName) {
        discountVO.name = defaultName;
      }
      if (get(discountVO, 'codes.length', 0) > 0) {
        discountVO.usePromotionCode = true;
      }
      const used = isDuplicate
        ? 0
        : get(discountVO, 'userLimitation.usedCount');
      setUsed(used);
      setCurrency(currency);
      form.setFields([{ name: 'description', value: discountVO.description }]);
      setActiveTime({ beginDate, beginTime, endDate, endTime });
      setGiftPurchaseFormData(discountVO);
      setSalesChannelName(salesChannelName);
      setLoading(false);
      setShowModal(false);
      setTimezoneInGmt(timezoneInGmt);
    });
  };

  const handleOnResponse = (response: any) => {
    const { data, status, errorCode, errMsg, code } = response;
    // console.log('response', response);
    if (data && status == 200) {
      return {
        valid: true,
        data: data.payload,
      };
    }
    if (errorCode == nameDuplicate && code == 400) {
      timeoutScroll(`${formName}_name`);
      form.setFields([{ name: 'name', errors: [errMsg] }]);
      return {
        valid: false,
      };
    }
    modal.error({
      title: getI18nFromGeneral('general.tools_server.requestError'),
      content: errMsg || 'System Error, Please Contact Admin',
      onCancel: () => {
        console.error(errMsg || 'System Error, Please Contact Admin');
      },
      onCancelText: 'Confirm',
    });

    return {
      valid: false,
    };
  };

  const onFinish = () => {
    setShowModal(false);
    const validate = isDraft
      ? form.validateFields(['name', 'codes'])
      : form.validateFields();
    validate.then(() => {
      const values = form.getFieldsValue();
      if (!activeTime.beginDate && !isDraft) {
        setActiveTimeError(true);
        return false;
      }
      values.status = giftPurchaseFormData.status || EnumStatus.Draft;
      values.uuid =
        discountUuid == NEW || duplicate === 'true' ? '' : discountUuid;
      values.salesChannelUuid = salesChannelUuid;
      (values.discountMethod || {}).discountType = 'GiftPurchase';
      saveGiftPurchase(
        { ...values, ...activeTime },
        { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
      ).then((res) => {
        const { valid, data } = handleOnResponse(res);
        if (valid) {
          const { hasError, uuid, status } = data;
          message.success('Save success');
          setHasModified(false);
          setGiftPurchaseFormData({ giftPurchaseFormData, hasError, status });
          if ((discountUuid == NEW || duplicate === 'true') && uuid) {
            history.replace(
              `/salesChannel/discounts/giftPurchase/editor/${salesChannelUuid}/${uuid}`,
            );
            eForceUpdate(uuid);
          }
        }
      });
    });
  };

  const handleOnEligibleConditionChange = (changedValues) => {
    const conditionType = get(changedValues, 'customerCondition.conditionType');
    const isEveryone = ECondition.Everyone === conditionType;
    if (isEveryone) {
      form.setFieldsValue({
        userLimitation: {
          maxPerCustomerEnabled: false,
          maxPerCustomer: null,
        },
      });
    }
  };

  const onValuesChange = (changedValues) => {
    handleOnEligibleConditionChange(changedValues);

    setHasModified(true);
  };

  const onGoBackClick = () => {
    history.push(
      `/salesChannel/discounts/giftPurchase/list/${salesChannelUuid}`,
    );
  };

  const statusChangeModal = ({ type, unSave, hasError }) => {
    const notAblePublishText = (
      <div>
        <div className={css.errorPublish}>
          {unSave
            ? `Please save change before ${type.toLocaleLowerCase()} this discount`
            : hasError
            ? 'Please fix all errors before publish'
            : 'Archiving will deactivate this discount. You may find the archived discount in the archive section and restore it at any time.'}
        </div>{' '}
        <ModalFooter
          onCancel={() => setShowModal(false)}
          okText={unSave ? 'Save Changes' : hasError ? 'Go to edit' : 'Archive'}
          onOk={() =>
            unSave
              ? onFinish()
              : hasError
              ? setShowModal(false)
              : handleChangeStatus(type)
          }
        />
      </div>
    );
    setModalContent(notAblePublishText);
    setModalTitle(
      unSave
        ? getI18n('general.saveChanges')
        : hasError
        ? getI18n('general.unabletoPublish')
        : getI18n('general.archiveDiscount'),
    );
    setShowModal(true);
  };

  const handleChangeStatus = (type) => {
    if (hasModified) {
      statusChangeModal({ type, unSave: hasModified, hasError: false });
    } else if (type == StatusChange.Duplicate) {
      handleClick({
        onClick: () => {
          history.replace(
            `/salesChannel/discounts/giftPurchase/editor/${salesChannelUuid}/${discountUuid}?duplicate=true`,
          );
        },
        title: getI18n('salesChannelGiftPurchase.list.createGiftPurchase'),
        content: getI18n('salesChannelGiftPurchase.list.gfArchive'),
        onOkText: getI18n('general.antd.Uploader.ok'),
        onCancelText: getI18n('general.cancel'),
        salesChannelUuid: salesChannelUuid,
      });
    } else {
      const changeStatusRequestList = {
        [StatusChange.Publish]: activateDiscount,
        [StatusChange.ToDraft]: draftDiscount,
        [StatusChange.Archive]: archiveDiscount,
      };
      changeStatusRequestList[type](discountUuid).then((data) => {
        setShowModal(false);
        handleRequestDetail(discountUuid);
      });
    }
  };

  const changeStatusList = {
    [EnumStatus.Draft]: [StatusChange.Archive, StatusChange.Publish],
    [EnumStatus.Active]: [StatusChange.Archive, StatusChange.ToDraft],
    [EnumStatus.Scheduled]: [StatusChange.Archive, StatusChange.ToDraft],
    [EnumStatus.Archived]: [StatusChange.Restore],
    [EnumStatus.Expired]: [StatusChange.Archive, StatusChange.ToDraft],
    undefined: [],
    null: [],
  };

  const handeleSetActiveTime = (value) => {
    setHasModified(true);
    setActiveTime(value);
  };

  const overlay = (
    <Menu>
      <MenuItem
        className={css.menuItem}
        onClick={() => {
          handleChangeStatus(StatusChange.Duplicate);
        }}
        disabled={!canEdit}>
        {getI18n('general.duplicate')}
      </MenuItem>
      <MenuItem
        className={css.menuItemArchive}
        disabled={!canDelete}
        onClick={() =>
          statusChangeModal({
            type: StatusChange.Archive,
            unSave: hasModified,
            hasError: false,
          })
        }>
        {getI18n('general.archive')}
      </MenuItem>
    </Menu>
  );

  const extendButton =
    discountUuid !== NEW && duplicate !== 'true' ? (
      <Fragment>
        {giftPurchaseFormData.status !== EnumStatus.Archived && (
          <DropDown.Button
            className={css.extendButton}
            overlay={overlay}
            placement='bottomRight'
            trigger={['click']}>
            {getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            )}
          </DropDown.Button>
        )}
        {changeStatusList[giftPurchaseFormData.status].includes(
          StatusChange.Restore,
        ) && (
          <Button
            disabled={!canEdit}
            className={css.extendButton}
            type='primary'
            onClick={() => handleChangeStatus(StatusChange.ToDraft)}
            ghost>
            {getI18n('general.restore')}
          </Button>
        )}
        {changeStatusList[giftPurchaseFormData.status].includes(
          StatusChange.Publish,
        ) && (
          <Button
            disabled={!canEdit}
            type='primary'
            className={css.extendButton}
            onClick={() =>
              giftPurchaseFormData.hasError
                ? statusChangeModal({
                    type: StatusChange.Publish,
                    unSave: hasModified,
                    hasError: true,
                  })
                : handleChangeStatus(StatusChange.Publish)
            }
            ghost>
            {getI18n('general.publish')}
          </Button>
        )}
        {changeStatusList[giftPurchaseFormData.status].includes(
          StatusChange.ToDraft,
        ) && (
          <Button
            disabled={!canEdit}
            type='primary'
            className={css.extendButton}
            onClick={() => handleChangeStatus(StatusChange.ToDraft)}
            ghost>
            {getI18n('general.switchToDraft')}
          </Button>
        )}
      </Fragment>
    ) : null;

  return canViewDetail ? (
    <div className={css.container}>
      <Skeleton loading={loading} active>
        <Form
          name={formName}
          form={form}
          initialValues={giftPurchaseFormData}
          onValuesChange={onValuesChange}
          className={css.editForm}>
          <CommonHeader
            breadcrumbData={breadcrumbData(
              salesChannelUuid,
              salesChannelName,
              discountUuid,
              { getI18n },
            )}
            onSaveDisable={!(hasModified || duplicate) || !canEdit}
            onSubmit={() => onFinish()}
            extraLeft={
              discountUuid !== NEW &&
              duplicate !== 'true' && (
                <div style={{ marginRight: 8 }}>
                  <MultiLangDropDown
                    hasModified={hasModified}
                    salesChannelUuidKey='uuid'
                    customType={
                      EnumMultiLanguageType.SalesChannelDiscountsGiftPurchase
                    }
                  />
                </div>
              )
            }
            onDiscard={onGoBackClick}
            onGoBackClick={onGoBackClick}
            extendButton={extendButton}
          />
          <div className={css.flashSaleContain}>
            <Summary
              status={giftPurchaseFormData.status}
              activeTime={activeTime}
            />
            <BasicInformation
              activeTime={activeTime}
              activeTimeError={activeTimeError}
              setActiveTimeError={setActiveTimeError}
              setActiveTime={handeleSetActiveTime}
              form={form}
              isPrimary={isPrimary}
              timezoneInGmt={timezoneInGmt}
              disableEdit={!canEdit}
            />

            {isPrimary && (
              <CustomerGets currency={currency} disableEdit={!canEdit} />
            )}
            {isPrimary && (
              <CustomerEligibleCondition
                form={form}
                disableEdit={!canEdit}
                disabledEveryoneDependency={maxPerCustomerCheckbox}
              />
            )}
            {isPrimary && (
              <OrderEligibleSection
                form={form}
                currency={currency}
                disableEdit={!canEdit}
              />
            )}
            {isPrimary && (
              <UsageLimitation disableEdit={!canEdit} used={used} />
            )}
            {isPrimary && <Attributes disableEdit={!canEdit} />}
          </div>
        </Form>
      </Skeleton>
    </div>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelHOC(SelectHOC(ModalHoc(GiftPurchaseEdit)), {
  type: EnumMultiLanguageType.SalesChannelDiscountsGiftPurchase,
});
